import { render, staticRenderFns } from "./ReportsFilter.vue?vue&type=template&id=fa406b20&scoped=true"
import script from "./ReportsFilter.vue?vue&type=script&lang=js"
export * from "./ReportsFilter.vue?vue&type=script&lang=js"
import style0 from "./ReportsFilter.vue?vue&type=style&index=0&id=fa406b20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa406b20",
  null
  
)

export default component.exports